import React from "react";
import { motion } from "framer-motion";
import { FileText, Home, Layers, Construction } from "lucide-react";

const PermitsOverview = ({ data }) => {
    if (!data || data.length === 0) return null;

    const getIcon = (category) => {
        if (category.toLowerCase().includes("residential")) return <Home size={20} />;
        if (category.toLowerCase().includes("multifamily")) return <Layers size={20} />;
        if (category.toLowerCase().includes("non-residential")) return <Construction size={20} />;
        return <FileText size={20} />;
    };

    return (
        <div className="mt-8">
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-orange-50 rounded-lg text-orange-600">
                    <FileText size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-800 m-0">Permits Overview (2025)</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {data.map((item, i) => (
                    <motion.div
                        key={i}
                        whileHover={{ y: -5 }}
                        className="bg-white p-5 rounded-3xl shadow-sm border border-gray-100"
                    >
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <div className="p-2 bg-gray-50 rounded-lg text-gray-400">
                                {getIcon(item.category)}
                            </div>
                        </div>
                        <h4 className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">{item.category}</h4>
                        <p className="text-xl font-bold text-gray-900 mb-1">
                            {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
                        </p>
                        {item.metric && (
                            <p className="text-xs text-blue-600 font-medium bg-blue-50 px-2 py-1 rounded inline-block">
                                {item.metric}
                            </p>
                        )}
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default PermitsOverview;
